import React from "react";
import {
  IconDashboard,
  IconHelpOutline,
  IconBilling,
  IconProfile,
  IconDescription,
} from "@origin-digital/ods-icons";
import { KrakenNavLinkType } from "./interfaces";
import { authNavRoutePrefix } from "./helpers/consts";

export interface INavConfig {
  name: string;
  title: string;
  icon?: React.ReactNode;
  linkType: KrakenNavLinkType;
  href: string;
  dropdownList?: INavConfig[];
  divider?: boolean;
  bold?: boolean;
}

export const generateFeedbackUrl = (formCode: string, title: string) =>
  `${authNavRoutePrefix}/feedback/?formCode=${formCode}&title=${encodeURIComponent(
    title
  )}`;

/*
 * Billing & Payments links
 */
export const paymentSettingsLink: INavConfig = {
  name: "payment-settings",
  title: "Payment settings",
  href: `${authNavRoutePrefix}/payment-settings`,
  linkType: KrakenNavLinkType.DROPDOWN,
};
export const selfMeterReadLink: INavConfig = {
  name: "self-meter-read",
  title: "Submit a meter read",
  linkType: KrakenNavLinkType.DROPDOWN,
  href: generateFeedbackUrl("rx_self_meter_read", "Submit a meter read"),
};

export const billingLink: INavConfig = {
  name: "billing-payments",
  title: "Billing & Payments",
  icon: <IconBilling />,
  href: "",
  linkType: KrakenNavLinkType.HEADER,
  dropdownList: [paymentSettingsLink, selfMeterReadLink],
};

/*
 * Plans & Properties links
 */
export const moveLink: INavConfig = {
  name: "move",
  title: "Move house",
  linkType: KrakenNavLinkType.DROPDOWN,
  href: `/moving.html?serviceId=ma:kraken:move`,
};
export const disconnectLink: INavConfig = {
  name: "disconnect",
  title: "Disconnect a property",
  linkType: KrakenNavLinkType.DROPDOWN,
  href: generateFeedbackUrl(
    "rx_disconnect_a_property",
    "Disconnect a property"
  ),
};

export const plansLink: INavConfig = {
  name: "plans-properties",
  title: "Plans & Properties",
  icon: <IconDescription />,
  href: "",
  linkType: KrakenNavLinkType.HEADER,
  dropdownList: [moveLink, disconnectLink],
};

/*
 * Account links
 */
export const logoutLink: INavConfig = {
  name: "logout",
  title: "Logout",
  linkType: KrakenNavLinkType.DROPDOWN,
  href: "/logout",
  bold: true,
  divider: true,
};
export const concessionLink: INavConfig = {
  name: "concession",
  title: "Add or edit concessions",
  href: `${authNavRoutePrefix}/concessions`,
  linkType: KrakenNavLinkType.DROPDOWN,
};
export const profileLink: INavConfig = {
  name: "profile",
  title: "View my profile",
  href: `${authNavRoutePrefix}/profile`,
  linkType: KrakenNavLinkType.DROPDOWN,
};

export const contactPrefsLink: INavConfig = {
  name: "contact-prefs",
  title: "Contact preferences",
  href: `${authNavRoutePrefix}/profile/contact-preferences`,
  linkType: KrakenNavLinkType.DROPDOWN,
};

export const contactUsLink: INavConfig = {
  name: "contact-us",
  title: "Feedback",
  href: generateFeedbackUrl("rx_contact_us", "Contact us"),
  linkType: KrakenNavLinkType.DROPDOWN,
};

export const spikeLink: INavConfig = {
  name: "spike",
  title: "Go to Spike",
  href: `${authNavRoutePrefix}/service/spike/redirect`,
  linkType: KrakenNavLinkType.DROPDOWN,
};

export const fuelOfferLink: INavConfig = {
  name: "fuel-offer",
  title: "Fuel discount offer",
  href: `${authNavRoutePrefix}/reward`,
  linkType: KrakenNavLinkType.DROPDOWN,
};

export const accountLink: INavConfig = {
  name: "account",
  title: "My Profile",
  icon: <IconProfile />,
  href: "",
  linkType: KrakenNavLinkType.HEADER,
  dropdownList: [
    profileLink,
    contactPrefsLink,
    concessionLink,
    spikeLink,
    fuelOfferLink,
    contactUsLink,
    logoutLink,
  ],
};

/*
 * Other links
 */
export const helpLink: INavConfig = {
  name: "help",
  title: "Help",
  icon: <IconHelpOutline />,
  linkType: KrakenNavLinkType.ASIDE,
  href: "/help-support",
};
export const dashboardLink: INavConfig = {
  name: "dashboard",
  title: "Dashboard",
  icon: <IconDashboard />,
  href: `${authNavRoutePrefix}`,
  linkType: KrakenNavLinkType.HEADER,
};

export const NavConfig: INavConfig[] = [
  dashboardLink,
  billingLink,
  plansLink,
  accountLink,
  helpLink,
];
